import { openZohoChat } from '../utils/openZohoChat';
import './SupportBlock.css';

export default function SupportBlock() {
  return (
    <section className="dh-support-block" id="support">
      <div className="dh-container dh-support-block__inner">
        <h2>Customer support</h2>
        <p>
          Round-the-clock Dragon technical assistance for setup, mic calibration, failed launches,
          activation, and day-to-day dictation accuracy. Chat with a real specialist — not a script
          that loops you in circles.
        </p>
        <button type="button" className="dh-btn dh-btn--outline" onClick={openZohoChat}>
          Learn More
        </button>
      </div>
    </section>
  );
}
